import MDS from "../../../../src/components/RenderImgs/mdsImgs";
import * as React from 'react';
export default {
  MDS,
  React
};